<script lang="ts">
  import type { ComponentProps } from "svelte";
  import {
    convertToButtonProps,
    type ButtonBlockProps,
  } from "./ButtonBlock.svelte";
  import { type ButtonSize, type ButtonVariant } from "@elements/Button.svelte";
  import StyledTextBlock from "../Text/StyledTextBlock.svelte";
  import ButtonCloud from "@components/buttons/ButtonCloud.svelte";

  export let buttons: ButtonBlockProps[];

  export let position: "center" | "start" | "end" = "start";
  export let className: string = "";
  const positionClasses = {
    center: "md:justify-center",
    start: "md:justify-start",
    end: "md:justify-end",
  };

  export let title: ComponentProps<StyledTextBlock>;
  export let variant: ButtonVariant | { value: ButtonVariant } = "primary";
  export let size: ButtonSize | { value: ButtonSize } = "small";

  export let flexClasses = "flex-col md:flex-row";
</script>

<ButtonCloud
  buttons={buttons.map(convertToButtonProps)}
  {title}
  variant={typeof variant === "object" ? variant.value : variant}
  size={typeof size === "object" ? size.value : size}
  {flexClasses}
  {position}
  {className}
/>
